import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as dom from '../../../../base/browser/dom.js';
import { createFastDomNode } from '../../../../base/browser/fastDomNode.js';
import { SmoothScrollableElement } from '../../../../base/browser/ui/scrollbar/scrollableElement.js';
import { PartFingerprints, ViewPart } from '../../view/viewPart.js';
import { getThemeTypeSelector } from '../../../../platform/theme/common/themeService.js';
export var EditorScrollbar = /*#__PURE__*/function (_ViewPart) {
  _inherits(EditorScrollbar, _ViewPart);

  var _super = _createSuper(EditorScrollbar);

  function EditorScrollbar(context, linesContent, viewDomNode, overflowGuardDomNode) {
    var _this;

    _classCallCheck(this, EditorScrollbar);

    _this = _super.call(this, context);
    var options = _this._context.configuration.options;
    var scrollbar = options.get(84
    /* scrollbar */
    );
    var mouseWheelScrollSensitivity = options.get(58
    /* mouseWheelScrollSensitivity */
    );
    var fastScrollSensitivity = options.get(28
    /* fastScrollSensitivity */
    );
    var scrollPredominantAxis = options.get(87
    /* scrollPredominantAxis */
    );
    var scrollbarOptions = {
      listenOnDomNode: viewDomNode.domNode,
      className: 'editor-scrollable' + ' ' + getThemeTypeSelector(context.theme.type),
      useShadows: false,
      lazyRender: true,
      vertical: scrollbar.vertical,
      horizontal: scrollbar.horizontal,
      verticalHasArrows: scrollbar.verticalHasArrows,
      horizontalHasArrows: scrollbar.horizontalHasArrows,
      verticalScrollbarSize: scrollbar.verticalScrollbarSize,
      verticalSliderSize: scrollbar.verticalSliderSize,
      horizontalScrollbarSize: scrollbar.horizontalScrollbarSize,
      horizontalSliderSize: scrollbar.horizontalSliderSize,
      handleMouseWheel: scrollbar.handleMouseWheel,
      alwaysConsumeMouseWheel: scrollbar.alwaysConsumeMouseWheel,
      arrowSize: scrollbar.arrowSize,
      mouseWheelScrollSensitivity: mouseWheelScrollSensitivity,
      fastScrollSensitivity: fastScrollSensitivity,
      scrollPredominantAxis: scrollPredominantAxis
    };
    _this.scrollbar = _this._register(new SmoothScrollableElement(linesContent.domNode, scrollbarOptions, _this._context.viewLayout.getScrollable()));
    PartFingerprints.write(_this.scrollbar.getDomNode(), 5
    /* ScrollableElement */
    );
    _this.scrollbarDomNode = createFastDomNode(_this.scrollbar.getDomNode());

    _this.scrollbarDomNode.setPosition('absolute');

    _this._setLayout(); // When having a zone widget that calls .focus() on one of its dom elements,
    // the browser will try desperately to reveal that dom node, unexpectedly
    // changing the .scrollTop of this.linesContent


    var onBrowserDesperateReveal = function onBrowserDesperateReveal(domNode, lookAtScrollTop, lookAtScrollLeft) {
      var newScrollPosition = {};

      if (lookAtScrollTop) {
        var deltaTop = domNode.scrollTop;

        if (deltaTop) {
          newScrollPosition.scrollTop = _this._context.viewLayout.getCurrentScrollTop() + deltaTop;
          domNode.scrollTop = 0;
        }
      }

      if (lookAtScrollLeft) {
        var deltaLeft = domNode.scrollLeft;

        if (deltaLeft) {
          newScrollPosition.scrollLeft = _this._context.viewLayout.getCurrentScrollLeft() + deltaLeft;
          domNode.scrollLeft = 0;
        }
      }

      _this._context.model.setScrollPosition(newScrollPosition, 1
      /* Immediate */
      );
    }; // I've seen this happen both on the view dom node & on the lines content dom node.


    _this._register(dom.addDisposableListener(viewDomNode.domNode, 'scroll', function (e) {
      return onBrowserDesperateReveal(viewDomNode.domNode, true, true);
    }));

    _this._register(dom.addDisposableListener(linesContent.domNode, 'scroll', function (e) {
      return onBrowserDesperateReveal(linesContent.domNode, true, false);
    }));

    _this._register(dom.addDisposableListener(overflowGuardDomNode.domNode, 'scroll', function (e) {
      return onBrowserDesperateReveal(overflowGuardDomNode.domNode, true, false);
    }));

    _this._register(dom.addDisposableListener(_this.scrollbarDomNode.domNode, 'scroll', function (e) {
      return onBrowserDesperateReveal(_this.scrollbarDomNode.domNode, true, false);
    }));

    return _this;
  }

  _createClass(EditorScrollbar, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(EditorScrollbar.prototype), "dispose", this).call(this);
    }
  }, {
    key: "_setLayout",
    value: function _setLayout() {
      var options = this._context.configuration.options;
      var layoutInfo = options.get(117
      /* layoutInfo */
      );
      this.scrollbarDomNode.setLeft(layoutInfo.contentLeft);
      var minimap = options.get(56
      /* minimap */
      );
      var side = minimap.side;

      if (side === 'right') {
        this.scrollbarDomNode.setWidth(layoutInfo.contentWidth + layoutInfo.minimap.minimapWidth);
      } else {
        this.scrollbarDomNode.setWidth(layoutInfo.contentWidth);
      }

      this.scrollbarDomNode.setHeight(layoutInfo.height);
    }
  }, {
    key: "getOverviewRulerLayoutInfo",
    value: function getOverviewRulerLayoutInfo() {
      return this.scrollbar.getOverviewRulerLayoutInfo();
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this.scrollbarDomNode;
    }
  }, {
    key: "delegateVerticalScrollbarMouseDown",
    value: function delegateVerticalScrollbarMouseDown(browserEvent) {
      this.scrollbar.delegateVerticalScrollbarMouseDown(browserEvent);
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      if (e.hasChanged(84
      /* scrollbar */
      ) || e.hasChanged(58
      /* mouseWheelScrollSensitivity */
      ) || e.hasChanged(28
      /* fastScrollSensitivity */
      )) {
        var options = this._context.configuration.options;
        var scrollbar = options.get(84
        /* scrollbar */
        );
        var mouseWheelScrollSensitivity = options.get(58
        /* mouseWheelScrollSensitivity */
        );
        var fastScrollSensitivity = options.get(28
        /* fastScrollSensitivity */
        );
        var scrollPredominantAxis = options.get(87
        /* scrollPredominantAxis */
        );
        var newOpts = {
          handleMouseWheel: scrollbar.handleMouseWheel,
          mouseWheelScrollSensitivity: mouseWheelScrollSensitivity,
          fastScrollSensitivity: fastScrollSensitivity,
          scrollPredominantAxis: scrollPredominantAxis
        };
        this.scrollbar.updateOptions(newOpts);
      }

      if (e.hasChanged(117
      /* layoutInfo */
      )) {
        this._setLayout();
      }

      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return true;
    }
  }, {
    key: "onThemeChanged",
    value: function onThemeChanged(e) {
      this.scrollbar.updateClassName('editor-scrollable' + ' ' + getThemeTypeSelector(this._context.theme.type));
      return true;
    } // --- end event handlers

  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {// Nothing to do
    }
  }, {
    key: "render",
    value: function render(ctx) {
      this.scrollbar.renderNow();
    }
  }]);

  return EditorScrollbar;
}(ViewPart);